import { removeFirstSubstring } from '../utils/removeFirstSubstring'

export interface ReceiptDataProps {
  serviceName?: string
  id?: string
}

export const getReceiptData = ({ serviceName, id }: ReceiptDataProps) => [
  {
    key: 'Услуга по переводу денежных средств',
    value: removeFirstSubstring(serviceName as string, 'Услуга: ') || '',
  },
  {
    key: 'Платеж сформирован',
    value: 'Сайт «МТС Оплата»',
  },
  {
    key: 'Номер операции',
    value: id,
  },
]
